var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/file/ppt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#ADB8BE",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 5,
    y: 1,
    width: 28,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19999981,18 L24.8000002,18 C26.5673113,18 28,19.4326887 28,21.1999998 L28,29.8000002 C28,31.5673113 26.5673113,33 24.8000002,33 L3.19999981,33 C1.43268872,33 2.16433187e-16,31.5673113 0,29.8000002 L0,21.1999998 C2.27656022e-16,19.4326887 1.43268872,18 3.19999981,18 Z",
    id: "Combined-Shape",
    fill: "#E9580A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42578087,29.4791671 L6.42578087,26.6354173 L7.15312457,26.6354173 C8.14479118,26.6354173 8.90950468,26.4075527 9.44726506,25.9518236 C9.98502545,25.4960945 10.2539056,24.8380216 10.2539056,23.977605 C10.2539056,23.1500008 10.0014317,22.5274748 9.49648381,22.1100269 C8.99153592,21.6925791 8.25416617,21.4838551 7.28437457,21.4838551 L7.28437457,21.4838551 L4.73046847,21.4838551 L4.73046847,29.4791671 L6.42578087,29.4791671 Z M6.98359333,25.2463549 L6.42578087,25.2463549 L6.42578087,22.8729175 L7.19687457,22.8729175 C7.65989538,22.8729175 7.99986931,22.9677092 8.21679639,23.1572925 C8.43372346,23.3468758 8.54218699,23.6403654 8.54218699,24.0377612 C8.54218699,24.4315112 8.41275992,24.731381 8.15390576,24.9373705 C7.89505161,25.1433601 7.50494747,25.2463549 6.98359333,25.2463549 L6.98359333,25.2463549 Z M13.4585929,29.4791671 L13.4585929,26.6354173 L14.1859367,26.6354173 C15.1776033,26.6354173 15.9423168,26.4075527 16.4800771,25.9518236 C17.0178375,25.4960945 17.2867177,24.8380216 17.2867177,23.977605 C17.2867177,23.1500008 17.0342438,22.5274748 16.5292959,22.1100269 C16.024348,21.6925791 15.2869783,21.4838551 14.3171866,21.4838551 L14.3171866,21.4838551 L11.7632805,21.4838551 L11.7632805,29.4791671 L13.4585929,29.4791671 Z M14.0164054,25.2463549 L13.4585929,25.2463549 L13.4585929,22.8729175 L14.2296867,22.8729175 C14.6927075,22.8729175 15.0326814,22.9677092 15.2496085,23.1572925 C15.4665355,23.3468758 15.5749991,23.6403654 15.5749991,24.0377612 C15.5749991,24.4315112 15.445572,24.731381 15.1867178,24.9373705 C14.9278637,25.1433601 14.5377596,25.2463549 14.0164054,25.2463549 L14.0164054,25.2463549 Z M21.8804674,29.4791671 L21.8804674,22.8947925 L24.0515611,22.8947925 L24.0515611,21.4838551 L18.0140614,21.4838551 L18.0140614,22.8947925 L20.185155,22.8947925 L20.185155,29.4791671 L21.8804674,29.4791671 Z",
    id: "PPT",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.516a1df5b5fd9a3023b8f58ba130b665.svg";
export { ForwardRef as ReactComponent };